import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { CopyAnimatedIcon, CopyButton, CopyTrigger } from '@/modules/shared/components/copy-button';
interface TxHashProps {
  txHash: string | null;
  className?: string;
}
function TxHash(t0) {
  const $ = _c(14);
  let props;
  let txHash;
  if ($[0] !== t0) {
    ({
      txHash,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = txHash;
  } else {
    props = $[1];
    txHash = $[2];
  }
  let t1;
  if ($[3] !== txHash) {
    t1 = !txHash ? "" : txHash.length <= 16 ? txHash : `${txHash.slice(0, 16)}...`;
    $[3] = txHash;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const formattedHash = t1;
  const t2 = `https://etherscan.io/tx/${txHash}`;
  let t3;
  if ($[5] !== formattedHash || $[6] !== t2) {
    t3 = <Link href={t2} target="_blank" className="text-status-progress text-xs/4.5 font-medium hover:opacity-80">{formattedHash}</Link>;
    $[5] = formattedHash;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== txHash) {
    t4 = txHash && <CopyButton value={txHash}><CopyTrigger><CopyAnimatedIcon className="size-4" /></CopyTrigger></CopyButton>;
    $[8] = txHash;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex items-center gap-0.5" {...props}>{t3}{t4}</div>;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export { TxHash };